/* ============================================================================
FILE: po-divers-collection-fr-en-es-20260727.js
ROLE: Description trilingue protégée de la rubrique « Divers ».
ROOT: [data-po-divers]
LANGUES: FR / EN / ES
STORAGE: po_lex_lang + goody_gp_lang
AUDIO: SpeechSynthesis, lecture du texte actif uniquement.
LIEN DE COLLECTION: aucun, la description étant affichée sur Divers.
============================================================================ */
(function(){
  "use strict";

  if (window.__PO_DIVERS_COLLECTION_20260727__) return;
  window.__PO_DIVERS_COLLECTION_20260727__ = true;

  var ROOT_SELECTOR = "[data-po-divers]";
  var STORAGE_KEY = "po_lex_lang";
  var STORAGE_KEY_COMPAT = "goody_gp_lang";
  var AUDIO_SYNTH = (typeof window !== "undefined" && window.speechSynthesis)
    ? window.speechSynthesis
    : null;

  var AUDIO_STATE = {
    root: null,
    chunks: [],
    index: 0,
    active: false
  };

  function clampStr(value){
    return value == null ? "" : String(value);
  }

  function escapeHTML(value){
    return clampStr(value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/\"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function canonical(value){
    return '<span class="po-divers-collection__canonical notranslate" translate="no">' +
      escapeHTML(value) +
      "</span>";
  }

  var CANON = {
    title: canonical("Divers")
  };

  var CONTENT = {
    fr: {
      ui: {
        group: "Choix de la langue",
        summary: "Description",
        audio: "Écouter",
        stop: "Arrêter",
        content: "Présentation de la rubrique Divers"
      },
      paragraphs: [
        CANON.title + " ouvre un parcours à travers mon travail depuis ses commencements. Cette rubrique rassemble des œuvres issues de différentes périodes, permettant d’observer les recherches, les déplacements, les continuités et les transformations qui ont accompagné l’évolution de ma pratique artistique.",

        "Elle accueille également quelques créations hors collection, demeurées autonomes tout en participant à l’ensemble de mon univers plastique. Chacune porte son histoire, son rythme, ses tensions et sa manière propre de prolonger les préoccupations qui traversent mon travail.",

        "Certaines de ces œuvres sont disponibles à l’acquisition. " + CANON.title + " devient ainsi un espace de découverte où se rencontrent les premières étapes de mon parcours, des expérimentations singulières et des œuvres accessibles à celles et ceux qui souhaitent les accueillir dans leur propre environnement."
      ]
    },

    en: {
      ui: {
        group: "Language selection",
        summary: "Description",
        audio: "Listen",
        stop: "Stop",
        content: "Presentation of the Divers section"
      },
      paragraphs: [
        CANON.title + " opens a journey through my work from its earliest beginnings. This section brings together works from different periods, making it possible to observe the research, shifts, continuities, and transformations that have accompanied the development of my artistic practice.",

        "It also presents several works created outside any collection, remaining autonomous while still participating in the wider body of my visual universe. Each carries its own history, rhythm, tensions, and particular way of extending the concerns that run through my work.",

        "Some of these works are available for acquisition. " + CANON.title + " thus becomes a space of discovery where the earliest stages of my path, singular experiments, and works available to those wishing to welcome them into their own environment come together."
      ]
    },

    es: {
      ui: {
        group: "Selección de idioma",
        summary: "Descripción",
        audio: "Escuchar",
        stop: "Detener",
        content: "Presentación de la sección Divers"
      },
      paragraphs: [
        CANON.title + " abre un recorrido por mi trabajo desde sus comienzos. Esta sección reúne obras procedentes de diferentes períodos y permite observar las investigaciones, los desplazamientos, las continuidades y las transformaciones que han acompañado la evolución de mi práctica artística.",

        "También acoge algunas creaciones realizadas fuera de toda colección, autónomas y, al mismo tiempo, vinculadas al conjunto de mi universo plástico. Cada una lleva su propia historia, su ritmo, sus tensiones y su manera particular de prolongar las preocupaciones que atraviesan mi trabajo.",

        "Algunas de estas obras están disponibles para su adquisición. " + CANON.title + " se convierte así en un espacio de descubrimiento donde se encuentran las primeras etapas de mi trayectoria, experimentaciones singulares y obras accesibles a quienes desean acogerlas en su propio entorno."
      ]
    }
  };


  function normLang(raw){
    var value = clampStr(raw).toLowerCase().trim().replace(/_/g, "-");

    if (value === "fr" || value.indexOf("fr-") === 0) return "fr";
    if (value === "en" || value.indexOf("en-") === 0) return "en";
    if (value === "es" || value.indexOf("es-") === 0) return "es";

    return "fr";
  }

  function readStoredLang(){
    var value = "";

    try {
      value = localStorage.getItem(STORAGE_KEY) || "";
    } catch(e) {
      value = "";
    }

    if (!value) {
      try {
        value = localStorage.getItem(STORAGE_KEY_COMPAT) || "";
      } catch(_e) {
        value = "";
      }
    }

    return value ? normLang(value) : "";
  }

  function getLang(){
    var stored = readStoredLang();
    var htmlLang = "";

    if (stored) return stored;

    try {
      htmlLang = document.documentElement.getAttribute("lang") || "";
    } catch(e) {
      htmlLang = "";
    }

    return htmlLang ? normLang(htmlLang) : "fr";
  }

  function storeLang(lang){
    var resolved = normLang(lang);

    try {
      localStorage.setItem(STORAGE_KEY, resolved);
    } catch(e) {}

    try {
      localStorage.setItem(STORAGE_KEY_COMPAT, resolved);
    } catch(_e) {}

    try {
      document.documentElement.setAttribute("lang", resolved);
    } catch(__e) {}

    return resolved;
  }

  function paragraphHTML(paragraphs){
    return paragraphs.map(function(paragraph){
      return '<p class="po-divers-collection__paragraph">' +
        paragraph +
        "</p>";
    }).join("");
  }

  function updateButtons(root, lang){
    var buttons = root.querySelectorAll("[data-po-lang]");

    Array.prototype.forEach.call(buttons, function(button){
      var active = normLang(button.getAttribute("data-po-lang")) === lang;

      button.classList.toggle("is-active", active);
      button.setAttribute("aria-pressed", active ? "true" : "false");
    });
  }

  function updateUI(root, lang){
    var data = CONTENT[lang] || CONTENT.fr;
    var group = root.querySelector("[data-po-language-group]");
    var summaryLabel = root.querySelector("[data-po-summary-label]");
    var content = root.querySelector("[data-po-content]");
    var audio = root.querySelector("[data-po-audio]");

    root.setAttribute("lang", lang);
    root.setAttribute("aria-label", data.ui.content);

    if (group) group.setAttribute("aria-label", data.ui.group);
    if (summaryLabel) summaryLabel.textContent = data.ui.summary;
    if (content) content.setAttribute("aria-label", data.ui.content);

    if (audio) {
      audio.hidden = !AUDIO_SYNTH;
      audio.textContent = AUDIO_STATE.active && AUDIO_STATE.root === root
        ? data.ui.stop
        : data.ui.audio;
      audio.setAttribute(
        "aria-pressed",
        AUDIO_STATE.active && AUDIO_STATE.root === root ? "true" : "false"
      );
    }

    updateButtons(root, lang);
  }

  function renderRoot(root, lang){
    if (!root) return;

    var resolved = normLang(lang);
    var data = CONTENT[resolved] || CONTENT.fr;
    var content = root.querySelector("[data-po-content]");

    stopAudio();

    if (content) {
      content.classList.add("is-changing");

      window.setTimeout(function(){
        content.innerHTML = paragraphHTML(data.paragraphs);
        content.setAttribute("lang", resolved);
        content.classList.remove("is-changing");
      }, 80);
    }

    updateUI(root, resolved);
  }

  function applyLangEverywhere(lang){
    var resolved = normLang(lang);
    var roots = document.querySelectorAll(ROOT_SELECTOR);

    Array.prototype.forEach.call(roots, function(root){
      renderRoot(root, resolved);
    });
  }

  function notifyLocaleChanged(lang){
    try {
      window.dispatchEvent(new CustomEvent("po:locale-changed", {
        detail: {
          lang: lang,
          source: "po-divers-collection"
        }
      }));
    } catch(e) {
      try {
        var event = document.createEvent("CustomEvent");
        event.initCustomEvent("po:locale-changed", true, true, {
          lang: lang,
          source: "po-divers-collection"
        });
        window.dispatchEvent(event);
      } catch(_e) {}
    }
  }

  function setLang(lang){
    var resolved = storeLang(lang);

    applyLangEverywhere(resolved);
    notifyLocaleChanged(resolved);

    return resolved;
  }

  function cleanAudioText(text){
    return clampStr(text)
      .replace(/\u00a0/g, " ")
      .replace(/\s+/g, " ")
      .trim();
  }

  function splitAudioText(text, maxLength){
    var clean = cleanAudioText(text);
    var limit = maxLength || 210;
    var sentences;
    var chunks = [];
    var current = "";

    if (!clean) return chunks;

    sentences = clean.match(/[^.!?…]+[.!?…]+|[^.!?…]+$/g) || [clean];

    sentences.forEach(function(sentence){
      var part = sentence.trim();

      if (!part) return;

      if (part.length > limit) {
        var words = part.split(/\s+/);

        words.forEach(function(word){
          var candidate = current ? current + " " + word : word;

          if (candidate.length > limit && current) {
            chunks.push(current.trim());
            current = word;
          } else {
            current = candidate;
          }
        });

        return;
      }

      if ((current + " " + part).trim().length > limit && current) {
        chunks.push(current.trim());
        current = part;
      } else {
        current = (current + " " + part).trim();
      }
    });

    if (current) chunks.push(current.trim());

    return chunks;
  }

  function voiceFor(lang){
    if (!AUDIO_SYNTH || typeof AUDIO_SYNTH.getVoices !== "function") {
      return null;
    }

    var voices = AUDIO_SYNTH.getVoices() || [];
    var locale = lang === "en" ? "en" : (lang === "es" ? "es" : "fr");
    var exact = null;
    var partial = null;

    voices.some(function(voice){
      var code = clampStr(voice.lang).toLowerCase();

      if (!exact && code === locale) exact = voice;
      if (!partial && code.indexOf(locale + "-") === 0) partial = voice;

      return Boolean(exact);
    });

    return exact || partial || null;
  }

  function refreshAudioButtons(){
    var roots = document.querySelectorAll(ROOT_SELECTOR);
    var lang = getLang();

    Array.prototype.forEach.call(roots, function(root){
      updateUI(root, lang);
    });
  }

  function resetAudioState(){
    AUDIO_STATE.root = null;
    AUDIO_STATE.chunks = [];
    AUDIO_STATE.index = 0;
    AUDIO_STATE.active = false;
    refreshAudioButtons();
  }

  function stopAudio(){
    if (AUDIO_SYNTH) {
      try {
        AUDIO_SYNTH.cancel();
      } catch(e) {}
    }

    resetAudioState();
  }

  function speakNext(){
    var root = AUDIO_STATE.root;
    var lang;
    var utterance;
    var voice;

    if (!AUDIO_SYNTH || !AUDIO_STATE.active || !root) {
      resetAudioState();
      return;
    }

    if (AUDIO_STATE.index >= AUDIO_STATE.chunks.length) {
      resetAudioState();
      return;
    }

    lang = normLang(root.getAttribute("lang") || getLang());
    utterance = new SpeechSynthesisUtterance(
      AUDIO_STATE.chunks[AUDIO_STATE.index]
    );
    voice = voiceFor(lang);

    utterance.lang = lang === "en"
      ? "en-US"
      : (lang === "es" ? "es-ES" : "fr-FR");
    utterance.rate = 0.94;
    utterance.pitch = 1;
    utterance.volume = 1;

    if (voice) utterance.voice = voice;

    utterance.onend = function(){
      AUDIO_STATE.index += 1;
      speakNext();
    };

    utterance.onerror = function(){
      resetAudioState();
    };

    AUDIO_SYNTH.speak(utterance);
  }

  function startAudio(root){
    var content;
    var text;

    if (!AUDIO_SYNTH || !root) return;

    if (AUDIO_STATE.active && AUDIO_STATE.root === root) {
      stopAudio();
      return;
    }

    stopAudio();

    content = root.querySelector("[data-po-content]");
    text = content ? content.textContent : "";

    AUDIO_STATE.root = root;
    AUDIO_STATE.chunks = splitAudioText(text, 210);
    AUDIO_STATE.index = 0;
    AUDIO_STATE.active = AUDIO_STATE.chunks.length > 0;

    refreshAudioButtons();

    if (AUDIO_STATE.active) speakNext();
  }

  function bindRoot(root){
    if (!root || root.getAttribute("data-po-bound") === "true") return;

    root.setAttribute("data-po-bound", "true");

    root.addEventListener("click", function(event){
      var langButton = event.target.closest("[data-po-lang]");
      var audioButton = event.target.closest("[data-po-audio]");

      if (langButton && root.contains(langButton)) {
        event.preventDefault();
        setLang(langButton.getAttribute("data-po-lang"));
        return;
      }

      if (audioButton && root.contains(audioButton)) {
        event.preventDefault();
        startAudio(root);
      }
    });
  }

  function initRoots(){
    var roots = document.querySelectorAll(ROOT_SELECTOR);
    var lang = getLang();

    Array.prototype.forEach.call(roots, function(root){
      bindRoot(root);
      renderRoot(root, lang);
    });
  }

  window.addEventListener("po:locale-changed", function(event){
    var detail = event && event.detail ? event.detail : null;
    var lang = detail && detail.lang ? detail.lang : getLang();

    if (detail && detail.source === "po-peyi-la-collection") return;

    applyLangEverywhere(lang);
  });

  window.addEventListener("storage", function(event){
    if (!event) return;

    if (event.key === STORAGE_KEY || event.key === STORAGE_KEY_COMPAT) {
      applyLangEverywhere(event.newValue || getLang());
    }
  });

  document.addEventListener("shopify:section:load", function(){
    initRoots();
  });

  document.addEventListener("shopify:section:unload", function(){
    stopAudio();
  });

  window.addEventListener("pagehide", function(){
    stopAudio();
  });

  window.PoDiversCollectionFR_EN_ES_20260727 = {
    getLang: getLang,
    setLang: setLang,
    init: initRoots,
    stopAudio: stopAudio
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initRoots, { once: true });
  } else {
    initRoots();
  }
})();
